import { api } from "./config"
import { useAuthStore } from "@/stores/authStore"

export const getShopActiveUsers = async (shopId: string) => {
    const accessToken = useAuthStore.getState().auth.accessToken

    const result = await api.get(`analytics/shop/${shopId}/active`, {
        headers: {
            'Authorization': `Bearer ${accessToken}`,
            'Content-Type': 'application/json',
        }
    }).then((response: any) => response.data.data)
    return result
}

export const getShopStats = async (shopId: string, startAt: number, endAt: number) => {
    const accessToken = useAuthStore.getState().auth.accessToken

    const result = await api.get(`analytics/shop/${shopId}/stats`, {
        headers: {
            'Authorization': `Bearer ${accessToken}`,
            'Content-Type': 'application/json',
        },
        params: {
            start_at: startAt,
            end_at: endAt
        }
    }).then((response: any) => {
        const data = response.data.data;
        const comparison = data.comparison || {};
        
        // Transform the flat structure to the expected nested structure
        return {
            pageviews: {
                value: data.pageviews || 0,
                prev: comparison.pageviews || 0
            },
            visitors: {
                value: data.visitors || 0,
                prev: comparison.visitors || 0
            },
            visits: {
                value: data.visits || 0,
                prev: comparison.visits || 0
            },
            bounces: {
                value: data.bounces || 0,
                prev: comparison.bounces || 0
            },
            totaltime: {
                value: data.totaltime || 0,
                prev: comparison.totaltime || 0
            }
        };
    })
    return result
}

export const getShopItemStats = async (shopId: string, startAt: number, endAt: number) => {
    const accessToken = useAuthStore.getState().auth.accessToken

    const result = await api.get(`analytics/shop/${shopId}/items`, {
        headers: {
            'Authorization': `Bearer ${accessToken}`,
            'Content-Type': 'application/json',
        },
        params: {
            start_at: startAt,
            end_at: endAt
        }
    }).then((response: any) => response.data.data)
    return result
}

export const getShopPageviews = async (shopId: string, startAt: number, endAt: number, unit:string) => {
    const accessToken = useAuthStore.getState().auth.accessToken

    const result = await api.get(`analytics/shop/${shopId}/pageviews`, {
        headers: {
            'Authorization': `Bearer ${accessToken}`,
            'Content-Type': 'application/json',
        },
        params: {
            start_at: startAt,
            end_at: endAt,
            unit: unit
        }
    }).then((response: any) => response.data.data)
    return result
}